import { Line } from "@ant-design/plots";
import { FC, useEffect, useState } from "react";
import { overviewData, overviewPhoneAndSmsData } from "./OverviewChartData";
import { fullUserSelector } from "src/store/user";
import { useSelector } from "react-redux";

export const OverviewChart: FC<{ data: string }> = ({ data }) => {
  const { sdBarCollapsed } = useSelector(fullUserSelector);
  const [chartWidth, setChartWidth] = useState<number>(700);

  // useEffect(() => {
  //   const updateWidth = () => {
  //     const container = document.querySelector(".ant-line-chart");
  //     if (container) {
  //       setChartWidth(container.clientWidth);
  //     }
  //   };

  //   updateWidth();
  //   window.addEventListener("resize", updateWidth);
  //   return () => window.removeEventListener("resize", updateWidth);
  // }, [sdBarCollapsed]);

  const config = {
    height: 236,
    // width: sdBarCollapsed ? 600 : "100%",
    forceFit: true,
    data,
    xField: "date",
    yField: "value",
    legend: { position: "right-top" },
    colorField: "type",
    shapeField: "smooth",
    scale: {
      color:
        // selectedChartType === "Emails"
        { range: ["#6048F3", "#01AEEF", "#0FCA7A", "#2B8F82", "#DA1818"] },
      // : { range: ["#6048F3", "#01AEEF", "#AF1EAA", "#37B9A8"] },
    },
    responsive: true,
  };
  return <Line {...config} />;
};
